import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EventData, Place, PlacePaginated } from 'src/models/place';

interface PlaceState {
  isLoading: boolean;
  isErrorMessage: string;
  statusCode: number;
  places: Place[];
  activePlace: Place | {} | any;
  placePaginated: Place[];
  page: number;
  limit: number;
  changePlace: null | Place | {};
  newPlaces: PlacePaginated;
  eventsByPlaces: EventData | null;
  isLoadingEvt: boolean;
  noRecordsMessage: string;
  totalEvents: number;
  noRecordsPlaces: string;
  existingName: string;
  confirm: boolean;
}

const initialState: PlaceState = {
  isLoading: false,
  statusCode: 201,
  isErrorMessage: '',
  places: [],
  activePlace: null,
  placePaginated: [],
  page: 0,
  limit: 25,
  changePlace: null,
  newPlaces: null,
  eventsByPlaces: null,
  isLoadingEvt: false,
  noRecordsMessage: '',
  totalEvents: 0,
  noRecordsPlaces: '',
  existingName: '',
  confirm: false,
};

export const placeSlice = createSlice({
  name: 'place',
  initialState,
  reducers: {
    startLoadingPlaces: (state) => {
      state.isLoading = true;
    },
    setPlaces: (state, action) => {
      state.isLoading = false;
      state.places = [...action.payload];
    },
    setPlacesPaginated: (state, action) => {
      state.isLoading = false;
      state.page = action.payload.page;
      state.placePaginated = action.payload.roles.data;
    },
    setChangePlace: (state, action) => {
      state.isLoading = false;
      state.changePlace = action.payload;
    },
    setError: (state, action) => {
      const message = action.payload.message;
      state.statusCode = action.payload.status;
      state.isErrorMessage = message;
    },
    stopLoadingPlaces: (state) => {
      state.isLoading = false;
    },
    setSelectedPlace: (state, action: PayloadAction<Place>) => {
      state.activePlace = action.payload;
    },
    setActivePlace: (state, action: PayloadAction<Place>) => {
      state.isLoading = false;
      state.activePlace = action.payload;
      state.places = [...state.places, action.payload];
    },
    setNewPlaces: (state, action) => {
      state.isLoading = false;
      state.newPlaces = action.payload;
    },
    setEventsByPlaces: (state, action) => {
      state.isLoadingEvt = false;
      state.eventsByPlaces = action.payload.results;
      state.totalEvents = action.payload.totalEvents;
    },
    startLoadingEvt: (state) => {
      state.isLoadingEvt = true;
    },
    stopLoadingEvt: (state) => {  
      state.isLoadingEvt = false;
    },
    setNoRecordsFound: (state, action) => {
      state.noRecordsMessage = action.payload;
    },
    setClearEventsByPlace: (state) => {
      state.eventsByPlaces = null;
      state.isLoadingEvt = false;
      state.noRecordsMessage = '';
      state.totalEvents= 0;
    },
    setNoRecordsPlaces: (state, action) => {
      state.noRecordsPlaces = action.payload
    },
    setExistingName: (state, action) => {
      state.existingName = action.payload;
    },
    setConfirm: (state, action) => {
      state.confirm = action.payload;
    },
  }
});

export const {
  startLoadingPlaces,
  setPlaces,
  setPlacesPaginated,
  setError,
  setChangePlace,
  stopLoadingPlaces,
  setSelectedPlace,
  setActivePlace,
  setNewPlaces,
  setEventsByPlaces,
  startLoadingEvt,
  stopLoadingEvt,
  setNoRecordsFound,
  setClearEventsByPlace,
  setNoRecordsPlaces,
  setExistingName,
  setConfirm,
} = placeSlice.actions;
